import { remove } from "lodash";

import {
  getWhatsappTemplates,
  getWhatsappTemplatesByCompanyAndChannel,
  deleteWhatsappTemplate,
  getWhatsappTemplateByChannel,
} from "../utils/whatsappTemplate";

const TEMPLATES_CHANNEL_TTL_MS = 60 * 60 * 1000;

const WHATSAPPTEMPLATES_STATE = {
  fetching: false,
  fetched: false,
  whatsappTemplateView: "initWhatsappTemplateView",
  createTemplate: {
    name: "",
    text: "",
    textWithFormat: "",
    originalText: "",
    variables: [],
    category: "",
    isVariables: false,
    channelId: "",
  },
  data: [],
  selected: {},
  fetchedByChannel: {},
  fetchingChannels: [],
};

const GET_WHATSAPPTEMPLATES_SUCESS = "GET_WHATSAPPTEMPLATES_SUCESS";
const GET_WHATSAPPTEMPLATES = "GET_WHATSAPPTEMPLATES";
const SET_SELECTED_WHATSAPPTEMPLATES = "SET_SELECTED_WHATSAPPTEMPLATES";
const UPDATE_CLIENT_WHATSAPPTEMPLATES = "UPDATE_CLIENT_WHATSAPPTEMPLATES";
const UPDATE_CLIENT_WHATSAPPTEMPLATES_END =
  "UPDATE_CLIENT_WHATSAPPTEMPLATES_END";
const SET_WATSAPP_TEMPLATE_VIEW = "SET_WATSAPP_TEMPLATE_VIEW";
const SET_WATSAPP_TEMPLATE_CATEGORY = "SET_WATSAPP_TEMPLATE_CATEGORY";
const SET_WATSAPP_TEMPLATE_TEXT = "SET_WATSAPP_TEMPLATE_TEXT";
const SET_WATSAPP_TEMPLATE_NAME = "SET_WATSAPP_TEMPLATE_NAME";
const SET_WATSAPP_TEMPLATE_VARIABLES = "SET_WATSAPP_TEMPLATE_VARIABLES";
const ADD_VARIABLE = "ADD_VARIABLE";
const SET_WATSAPP_TEMPLATE_WITH_VARIABLES =
  "SET_WATSAPP_TEMPLATE_WITH_VARIABLES";
const SET_TEXT_FORMAT = "SET_TEXT_FORMAT";
const RESET_CREATE_TEMPLATE = "RESET_CREATE_TEMPLATE";
const SET_ORIGINAL_TEXT = "SET_ORIGINAL_TEXT";
const SET_CHANEL_ID = "SET_CHANEL_ID";
const MERGE_TEMPLATES_BY_CHANNEL_START = "MERGE_TEMPLATES_BY_CHANNEL_START";
const MERGE_TEMPLATES_BY_CHANNEL_SUCCESS = "MERGE_TEMPLATES_BY_CHANNEL_SUCCESS";
const MERGE_TEMPLATES_BY_CHANNEL_FAILURE = "MERGE_TEMPLATES_BY_CHANNEL_FAILURE";
const INVALIDATE_TEMPLATES_CHANNEL_CACHE =
  "INVALIDATE_TEMPLATES_CHANNEL_CACHE";

export default function whatsappTemplatesReducer(
  state = WHATSAPPTEMPLATES_STATE,
  action
) {
  const { type, payload } = action;

  switch (type) {
    case GET_WHATSAPPTEMPLATES:
      return { ...state, fetching: true };
    case GET_WHATSAPPTEMPLATES_SUCESS:
      return { ...state, fetching: false, data: payload };
    case SET_SELECTED_WHATSAPPTEMPLATES:
      return { ...state, selected: payload };
    case UPDATE_CLIENT_WHATSAPPTEMPLATES:
      return { ...state, fetching: true };
    case UPDATE_CLIENT_WHATSAPPTEMPLATES_END:
      return { ...state, fetching: false };
    case SET_WATSAPP_TEMPLATE_VIEW:
      return { ...state, whatsappTemplateView: payload.whatsappTemplateView };
    case SET_WATSAPP_TEMPLATE_CATEGORY:
      return {
        ...state,
        createTemplate: { ...state.createTemplate, category: payload.category },
      };
    case SET_WATSAPP_TEMPLATE_WITH_VARIABLES:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          isVariables: payload.isVariables,
        },
      };
    case SET_WATSAPP_TEMPLATE_TEXT:
      return {
        ...state,
        createTemplate: { ...state.createTemplate, text: payload.text },
      };
    case SET_WATSAPP_TEMPLATE_NAME:
      return {
        ...state,
        createTemplate: { ...state.createTemplate, name: payload.name },
      };
    case SET_WATSAPP_TEMPLATE_VARIABLES:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          variables: payload.variables,
          isVariables: payload.isVariables,
        },
      };
    case ADD_VARIABLE:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          variables: [...state.createTemplate.variables, payload.variable],
        },
      };
    case SET_TEXT_FORMAT:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          textWithFormat: payload.textWithFormat,
        },
      };
    case RESET_CREATE_TEMPLATE:
      return {
        ...state,
        createTemplate: {
          name: "",
          text: "",
          textWithFormat: "",
          variables: [],
          category: "",
          isVariables: false,
        },
      };
    case SET_ORIGINAL_TEXT:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          originalText: payload.originalText,
        },
      };
    case SET_CHANEL_ID:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          channelId: payload.channelId,
        },
      };
    case MERGE_TEMPLATES_BY_CHANNEL_START:
      return {
        ...state,
        fetching: true,
        fetchingChannels: [...state.fetchingChannels, payload.channelId],
      };
    case MERGE_TEMPLATES_BY_CHANNEL_SUCCESS: {
      const { channelId, templates, timestamp } = payload;
      const dataWithoutThisChannel = state.data.filter(
        (t) => t.channelId !== channelId
      );
      return {
        ...state,
        fetching: false,
        data: [...dataWithoutThisChannel, ...templates],
        fetchedByChannel: {
          ...state.fetchedByChannel,
          [channelId]: timestamp,
        },
        fetchingChannels: state.fetchingChannels.filter(
          (id) => id !== channelId
        ),
      };
    }
    case MERGE_TEMPLATES_BY_CHANNEL_FAILURE:
      return {
        ...state,
        fetching: false,
        fetchingChannels: state.fetchingChannels.filter(
          (id) => id !== payload.channelId
        ),
      };
    case INVALIDATE_TEMPLATES_CHANNEL_CACHE: {
      const next = { ...state.fetchedByChannel };
      delete next[payload.channelId];
      return { ...state, fetchedByChannel: next };
    }

    default:
      return state;
  }
}

export const getWhatsappTemplatesByCompanyAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_WHATSAPPTEMPLATES });
      const companyId = getState().user.data.company.id;
      console.log("companyId", companyId);
      const whatsappTemplates = await getWhatsappTemplates(companyId);
      console.log("getWhatsappTemplates", whatsappTemplates);
      dispatch({
        type: GET_WHATSAPPTEMPLATES_SUCESS,
        payload: whatsappTemplates,
      });
      return whatsappTemplates;
    } catch (error) {
      throw error;
    }
  };

export const getWhatsappTemplatesByChannelAction =
  (channelId) => async (dispatch) => {
    try {
      dispatch({ type: GET_WHATSAPPTEMPLATES });
      const whatsappTemplates = await getWhatsappTemplateByChannel(channelId);
      dispatch({
        type: GET_WHATSAPPTEMPLATES_SUCESS,
        payload: whatsappTemplates,
      });
      return whatsappTemplates;
    } catch (error) {
      throw error;
    }
  };

export const loadTemplatesForChannelAction =
  (channelId) => async (dispatch, getState) => {
    if (!channelId) {
      return dispatch(getWhatsappTemplatesByCompanyAction());
    }

    const { fetchedByChannel, fetchingChannels } = getState().whatsappTemplates;

    const fetchedAt = fetchedByChannel[channelId];
    if (fetchedAt && Date.now() - fetchedAt < TEMPLATES_CHANNEL_TTL_MS) {
      return;
    }

    if (fetchingChannels.includes(channelId)) return;

    const companyId = getState().user.data.company.id;
    dispatch({
      type: MERGE_TEMPLATES_BY_CHANNEL_START,
      payload: { channelId },
    });
    try {
      const templates = await getWhatsappTemplatesByCompanyAndChannel(
        companyId,
        channelId
      );
      dispatch({
        type: MERGE_TEMPLATES_BY_CHANNEL_SUCCESS,
        payload: { channelId, templates, timestamp: Date.now() },
      });
      return templates;
    } catch (error) {
      dispatch({
        type: MERGE_TEMPLATES_BY_CHANNEL_FAILURE,
        payload: { channelId },
      });
      throw error;
    }
  };

export const invalidateTemplatesChannelCacheAction = (channelId) => ({
  type: INVALIDATE_TEMPLATES_CHANNEL_CACHE,
  payload: { channelId },
});

export const eraseWhatsappTemplatesAction =
  (id, name, channelId) => async (dispatch, getState) => {
    try {
      const responce = await deleteWhatsappTemplate(id, name, channelId);

      if (!responce) {
        dispatch({
          type: INVALIDATE_TEMPLATES_CHANNEL_CACHE,
          payload: { channelId },
        });
      }

      return responce;
      // remove(newWHATSAPPTEMPLATES, ['id', response.id]);
    } catch (error) {
      throw error;
    }
  };

export const setSelectedWhatsappTemplatesAction =
  (WhatsappTemplates) => async (dispatch) => {
    try {
      dispatch({
        type: SET_SELECTED_WHATSAPPTEMPLATES,
        payload: WhatsappTemplates,
      });
    } catch (error) {
      throw error;
    }
  };

export const setWhatsappTemplateView =
  (whatsappTemplateView) => async (dispatch) => {
    try {
      // dispatch({ type: GET_WHATSAPPTEMPLATES });
      const payload = { whatsappTemplateView };
      dispatch({ type: SET_WATSAPP_TEMPLATE_VIEW, payload });
      return;
    } catch (error) {
      throw error;
    }
  };
export const setWhatsappTemplateIsVariables =
  (isVariables) => async (dispatch) => {
    try {
      // dispatch({ type: GET_WHATSAPPTEMPLATES });
      const payload = { isVariables };
      dispatch({ type: SET_WATSAPP_TEMPLATE_WITH_VARIABLES, payload });
      return;
    } catch (error) {
      throw error;
    }
  };
export const setWhatsappTemplateCategory = (category) => async (dispatch) => {
  try {
    // dispatch({ type: GET_WHATSAPPTEMPLATES });
    const payload = { category };
    dispatch({ type: SET_WATSAPP_TEMPLATE_CATEGORY, payload });
    return;
  } catch (error) {
    throw error;
  }
};
export const setWhatsappTemplateText = (text) => async (dispatch) => {
  try {
    // dispatch({ type: GET_WHATSAPPTEMPLATES });
    const payload = { text };
    dispatch({ type: SET_WATSAPP_TEMPLATE_TEXT, payload });
    return;
  } catch (error) {
    throw error;
  }
};
export const setWhatsappTemplateNameAction = (name) => async (dispatch) => {
  try {
    // dispatch({ type: GET_WHATSAPPTEMPLATES });
    const payload = { name };
    dispatch({ type: SET_WATSAPP_TEMPLATE_NAME, payload });
    return;
  } catch (error) {
    throw error;
  }
};
export const setWhatsappTemplateVariablesAction =
  (variables, isVariables) => async (dispatch) => {
    try {
      // dispatch({ type: GET_WHATSAPPTEMPLATES });
      const payload = { variables, isVariables };
      dispatch({ type: SET_WATSAPP_TEMPLATE_VARIABLES, payload });
      return;
    } catch (error) {
      throw error;
    }
  };

export const addVariableAction = (variable) => async (dispatch) => {
  try {
    dispatch({ type: ADD_VARIABLE, payload: variable });
    return;
  } catch (error) {
    throw error;
  }
};

export const setTextWithFormatAction = (textWithFormat) => async (dispatch) => {
  try {
    console.log(textWithFormat);
    const payload = { textWithFormat };
    dispatch({ type: SET_TEXT_FORMAT, payload });
    return;
  } catch (error) {
    throw error;
  }
};
export const setOriginalTextAction = (originalText) => async (dispatch) => {
  try {
    console.log(originalText);
    const payload = { originalText };
    dispatch({ type: SET_ORIGINAL_TEXT, payload });
    return;
  } catch (error) {
    throw error;
  }
};

export const resetCreateTemplate = () => ({
  type: RESET_CREATE_TEMPLATE,
});

export const setChannelIdAction = (channelId) => async (dispatch) => {
  try {
    const payload = { channelId };
    dispatch({ type: SET_CHANEL_ID, payload });
    return;
  } catch (error) {
    throw error;
  }
};
